// extracted by css-extract-rspack-plugin
export default {"row":"aHAcA","nowrap":"CO3aW"};